<template>
  <div class="content-block-wrap content-layout">
    <VLessonLayout v-if="!hasRenderError" :model-value="block" mode="view" />
    <div v-else class="content-layout__error">
      Layout block is temporarily unavailable.
    </div>
  </div>
</template>

<script setup lang="ts">
import { onErrorCaptured, ref } from 'vue'
import type { ContentBlock } from '../contentBlock.types'
import { VLessonLayout } from '@bibleawr/lesson-elements-v2'

const props = withDefaults(
  defineProps<{
    block: ContentBlock
    showAnswers?: boolean
  }>(),
  { showAnswers: false },
)

const hasRenderError = ref(false)

onErrorCaptured((error) => {
  hasRenderError.value = true
  if (import.meta.dev) {
    console.error('[VContentBlockLayout] layout render error:', error)
  }
  return false
})

</script>

<style scoped>
.content-layout {
  margin: 0 0 24px;
}

.content-layout__error {
  margin: 0;
  padding: 16px;
  color: #9ca3af;
  font-size: 0.9rem;
  text-align: center;
  border: 1px dashed #e5e7eb;
  border-radius: 8px;
}
</style>
